import { round } from './utils'

interface HumanizeDurationOptions {
  short?: boolean
}

export const pluralize = (count: number, singular: string, plural: string): string =>
  count === 1 ? singular : plural

export const duration = (ms: number, options?: HumanizeDurationOptions): string => {
  const short = options?.short ?? false

  const seconds = Math.floor(ms / 1000)
  const minutes = Math.floor(seconds / 60)
  const hours = Math.floor(minutes / 60)

  if (hours > 0) {
    if (short) {
      return `${round(hours)}h`
    }

    return `${round(hours)} ${pluralize(round(hours), 'hour', 'hours')}`
  }

  if (minutes > 0) {
    if (short) {
      return `${round(minutes)}m`
    }

    return `${round(minutes)} ${pluralize(round(minutes), 'minute', 'minutes')}`
  }

  if (short) {
    return `${round(seconds)}s`
  }

  return `${round(seconds)} ${pluralize(round(seconds), 'second', 'seconds')}`
}

export const ordinal = (n: number): string => {
  const s = ['th', 'st', 'nd', 'rd']
  const v = n % 100

  return n + (s[(v - 20) % 10] || s[v] || s[0] || '')
}

export const currency = (value: number): string =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(value)

export const formatDate = (value: string): string =>
  new Intl.DateTimeFormat('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric'
  }).format(new Date(value))
